// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-uploader[data-v-0d492166]{display:block}.tips[data-v-0d492166]{font-size:16px;color:#3f9775}.right p[data-v-0d492166]{font-size:12px;margin:2px 0 2px}.bottom p[data-v-0d492166]{border-top:1px solid #3f9775;margin:10px 10%;font-size:16px;padding-bottom:10px}.bottom p[data-v-0d492166],footer[data-v-0d492166]{width:80%;text-align:center}footer[data-v-0d492166]{bottom:5px;position:relative;margin:5px 10%}[data-v-0d492166]:export{green:#3f9775;white:#fff}", ""]);
// Exports
module.exports = exports;
